<template>
  <el-container direction="vertical"
                element-loading-text="加载中">
    <Header />
    <div class="advertisement"
         v-if="$route.meta.title!='首页'&& topShow">
      <i class="el-icon-circle-close"
         style="z-index: 999;"
         @click="close('topShow')"></i>
      <a :href="adDetailsTop.blogroll"
         target="_blank"
         v-if="!adDetailsTop.isStop">
        <img v-if="!adDetailsTop.isStop"
             :src="adDetailsTop.pcImgUrl"
             alt="">
      </a>
    </div>

    <el-container class="contetn-box">

      <Nav :menuList="menuList"
           ref="nav" />

      <el-main>
        <div style="margin: 10px 0">
          <tabs></tabs>
        </div>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </el-main>

    </el-container>
    <div class="advertisement"
         v-if="$route.meta.title!='首页'&& bottomShow"
         style="margin-bottom: 40px;">
      <i class="el-icon-circle-close"
         style="z-index: 999;"
         @click="close('bottomShow')"></i>
      <a :href="adDetailsBottom.blogroll"
         target="_blank"
         v-if="!adDetailsBottom.isStop">
        <img v-if="!adDetailsBottom.isStop"
             :src="adDetailsBottom.pcImgUrl"
             alt="">
      </a>
    </div>
    <el-footer height="30px"
               style="
        text-align: center;
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 999;
      ">
      <div class="footer-left">
        <a href="http://www.rayqee.com/index.html"
           target="_blank">首页</a>
        <a href="http://www.rayqee.com/index.html#AboutUs"
           target="_blank">关于我们</a>
        <a href="http://www.rayqee.com/index.html#News"
           target="_blank">企业动态</a>
        <a href="http://www.rayqee.com/index.html#FunctionFeature"
           target="_blank">功能亮点</a>
        <a href="http://www.rayqee.com/index.html#CooperatedPartner"
           target="_blank">合作伙伴</a>
        <a href="http://www.rayqee.com/articleList.html?type=CooperativeNews"
           target="_blank">合作新闻</a>
        <a href="http://www.rayqee.com/articleList.html?type=MediaNews"
           target="_blank">传媒资讯</a>
        <a href="http://www.rayqee.com/index.html#JoinUs"
           target="_blank">加盟代理</a>
        <a href="http://www.rayqee.com/creating/index.html"
           target="_blank">加盟代理</a>
      </div>
      <div>
        CopyRight©{{ year }} <a href="http://www.rayqee.com/">珠海瑞启智慧科技有限公司</a> 粤ICP备2023115920号-1
      </div>
      <div class="footer-right">
        版本：V0.99.3.2 RC &nbsp; &nbsp; &nbsp; 技术支持：
        <span style="color: #048cf8; cursor: pointer"
              @click="nav">易奇科技</span>
      </div>
    </el-footer>
    <div class="fixed-bottom animate-float"
         @click="kefu">
      <div class="bg-blue-hover p-3-rounded">
        <i class="el-icon-service"></i>
      </div>
    </div>
    <el-dialog title="联系客服"
               :visible.sync="QRVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="400px"
               center
               @close="QRVisible = false">
      <div class="contact-info">
        <!-- 电话咨询 -->
        <div class="contact-item">
          <div class="contact-icon phone-icon"><i class="el-icon-phone"></i></div>
          <div class="contact-text">
            <div class="contact-label">电话咨询</div>
            <div class="contact-value">13600360639</div>
          </div>
        </div>

        <!-- 邮箱咨询 -->
        <div class="contact-item">
          <div class="contact-icon email-icon">✉️</div>
          <div class="contact-text">
            <div class="contact-label">邮箱咨询</div>
            <div class="contact-value">i.lion@qq.com</div>
          </div>
        </div>

        <!-- 服务时间 -->
        <!-- <div class="service-time">
          <div class="contact-text">
            <div class="contact-label">服务时间</div>
            <div class="contact-value">周一至周五 9:00-18:00<br>周六至周日 10:00-17:00</div>
          </div>
        </div> -->
      </div>

      <!-- 微信二维码 -->
      <div class="qr-section">
        <div class="qr-title">微信咨询</div>
        <div class="qr-code">
          <div class="qr-placeholder">
            <img style="width: 100%;"
                 src="../assets/img/weixinkefu.png"
                 alt="">
          </div>
          <div class="qr-tip">扫码添加微信客服</div>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import Header from "@/components/Header";
import Nav from "@/components/Nav";
import tabs from "@/components/tabs";
import { AdDetails } from "@/utils/mixin";

export default {
  components: {
    Header,
    Nav,
    tabs,
  },
  mixins: [AdDetails],

  data () {
    return {
      menuList: [],
      Company: "",
      loading: false,
      year: "",
      bottomShow: false,
      topShow: false,
      adDetailsTop: '',
      adDetailsBottom: '',
      QRVisible: false
    };
  },
  created () {
    this.CompanyDetail();
    var date = new Date();
    this.year = date.getFullYear();
    this.getAdDetails('305561b8-8bac-4419-9944-5bae1ac41ab1', this, 'adDetailsTop');
    this.getAdDetails('e61a4b9b-6160-4593-ab3c-bccb4303e22d', this, 'adDetailsBottom');
    this.handleAuthAndRemoveParam();
  },
  watch: {

    adDetailsTop (val) {
      if (val.pcImgUrl && !val.isStop) {
        this.topShow = true
      }
    },
    adDetailsBottom (val) {
      if (val.pcImgUrl && !val.isStop) {
        this.bottomShow = true
      }
    },
  },
  methods: {
    handleAuthAndRemoveParam () {
      const urlParams = new URLSearchParams(window.location.hash.includes('?') ? window.location.hash.split('?')[1] : window.location.search.slice(1));
      const auth = urlParams.get('Authorization') || '';

      if (auth) {
        window.history.replaceState({}, document.title, window.location.origin);

      }
    },
    kefu () {
      this.QRVisible = true;
    },
    // getMenuChildren(pid, list) {
    //   const children = [];
    //   list.forEach((v) => {
    //     if (v.parentId == pid) {
    //       children.push(v);
    //     }
    //   });
    //   return children;
    // },
    close (value) {
      this[value] = false;
    },
    nav () {
      window.open("https://www.eqlee.com/", "_blank");
    },
    CompanyDetail () {
      this.$api.user.CompanyDetail().then((res) => {
        if (res.code === 0) {
          this.Company = res.data;
          this.getRightsMenus();
        }
      });
    },
    getRightsMenus () {

      this.loading = true;
      let sendData = {}
      if (!this.Company.companyName) {
        sendData.flag = 'woyou-c'
      } else {

        sendData.flag = 'woyou1'
      }
      this.$api.user.getRightsMenus('', sendData.flag).then((res) => {
        this.loading = false;

        // console.log(res);
        if (res.code == 0) {
          res.data.forEach((v) => {
            if (v.parentId == 0) {
              if (v.id == 59 && this.Company.authenticationState == 0) {
                return;
              }
              this.menuList.push(v);
              //把报表菜单id缓存至本地
              if (v.actionUrl == "data") {
                window.sessionStorage.setItem("mRportId", v.id);
              }

              //localMenu.push({v});
            }
          });
          this.$store.commit("saveMenus", this.menuList);
        }
        this.$nextTick(() => {
          this.$store.commit("navHeight", this.$refs.nav.$el.offsetHeight);
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
/* 咨询方式容器 */
.contact-info {
  margin-bottom: 30px;
}

.contact-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 12px;
  transition: all 0.2s ease;
}

.contact-item:hover {
  background: #e8f0fe;
  transform: translateX(4px);
}

.contact-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  font-size: 18px;
  color: white;
}

.phone-icon {
  background: linear-gradient(135deg, #4caf50, #45a049);
}

.email-icon {
  background: linear-gradient(135deg, #ff9800, #f57c00);
}

.time-icon {
  background: linear-gradient(135deg, #2196f3, #1976d2);
}

.contact-text {
  flex: 1;
}

.contact-label {
  font-weight: 600;
  color: #333;
  font-size: 14px;
  margin-bottom: 4px;
}

.contact-value {
  color: #666;
  font-size: 14px;
  line-height: 1.4;
}

/* 服务时间 */
.service-time {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  color: #1565c0;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 30px;
}

.service-time .contact-label {
  color: #1565c0;
  font-weight: 600;
}

.service-time .contact-value {
  color: #0d47a1;
  font-size: 14px;
  line-height: 1.4;
}

/* 微信二维码区域 */
.qr-section {
  text-align: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
}

.qr-title {
  font-weight: 600;
  color: #333;
  font-size: 16px;
  margin-bottom: 16px;
}

.qr-code {
  width: 120px;
  height: 120px;
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #999;
  flex-direction: column;
}

.qr-placeholder {
  width: 80px;
  height: 80px;
  background: #f0f0f0;
  border-radius: 8px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ccc;
  font-size: 10px;
}

.qr-tip {
  font-size: 12px;
  color: #666;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .customer-service {
    bottom: 20px;
    right: 20px;
    width: 56px;
    height: 56px;
  }

  .customer-service svg {
    width: 24px;
    height: 24px;
  }

  .modal-content {
    padding: 30px 20px;
    width: 95vw;
  }

  .modal-title {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .contact-item {
    padding: 12px;
  }

  .contact-icon {
    width: 36px;
    height: 36px;
    font-size: 16px;
    margin-right: 12px;
  }
}
.el-icon-service {
  font-size: 24px;
  color: white;
}
.fixed-bottom {
  z-index: 999;
  cursor: pointer;
  position: fixed;
  bottom: 5rem;
  right: 1rem;
}
.bg-blue-hover {
  background-color: #3b82f6;
  transition: background-color 0.3s;
}
.bg-blue-hover:hover {
  background-color: #1d4ed8;
}
.p-3-rounded {
  padding: 0.75rem;
  border-radius: 9999px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes float {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}
.animate-float {
  animation: float 2s infinite;
}
.el-icon-circle-close {
  font-size: 25px;
  position: absolute;
  right: 0;
  cursor: pointer;
}
.contetn-box {
  padding-bottom: 20px;
}
.advertisement {
  width: 100%;
  position: relative;
  height: 92px;
  // padding: 0 40px;
}
.footer-left,
.footer-right {
  width: 500px;
  text-align: left;
  padding-right: 20px;
  width: 550px;
  text-align: right;
}
.footer-left {
  text-align: left;
  a {
    margin-right: 10px;
    &:hover {
      color: #048cf8;
    }
  }
}
.el-container {
  height: 100%;
  overflow: hidden;
}
.el-aside {
  width: 200px !important;
  background-color: #fff;
}
.el-main {
  padding: 10px 30px 0px !important;
  // margin: 0 15px;
  overflow-x: hidden;
  // overflow-y: hidden;
}
.el-footer {
  // background-color: #fff;
  // border-top: 1px solid #ddd;
  background-color: rgb(243, 244, 248);
  // line-height: 34px;
  font-size: 12px;
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  width: 100%;
}
a {
  text-decoration: none; /* 去除下划线 */
  color: inherit; /* 继承父元素的颜色 */
  margin: 0; /* 去除外边距 */
  padding: 0; /* 去除内边距 */
}
</style>

